import { isDate, isValid } from 'date-fns'

/**
 * No return value, but throws an error if `date` is not a valid `Date`.
 */
export function ensureValidDate(date: Date, name: string = 'date') {
  if (!isDate(date))
    throw new TypeError(
      // @ts-expect-error `date` is not Date
      `${name} is a ${date.constructor.name}, not a Date: ${JSON.stringify(date)}`
    )
  if (!isValid(date))
    throw new RangeError(`${name} is not a valid Date: ${JSON.stringify(date)}`)
}
